import { setLayout } from '@/features/layout/set-layout';

import {
  OrganiseSurveyView,
  getServerSideProps,
} from '../../features/surveys/views/organise-survey';

export default setLayout({
  Page: OrganiseSurveyView,
});

export { getServerSideProps };
